import moment from 'moment';
import { templatesQuery } from './graphql/template.queries';
import { apolloClient } from '@/apollo';
import { IDocument } from '@/types/Document';

export class TemplateService {
  static async loadTemplates(
    folderId?: string,
    offset?: number,
    limit?: number,
    search?: string
  ): Promise<{ templates: IDocument[]; totalCount: number }> {
    const {
      data: { templates },
    } = await apolloClient.query({
      query: templatesQuery,
      variables: {
        folderId,
        offset,
        limit,
        search,
      },
      fetchPolicy: 'network-only',
    });
    return { templates: correctDates(templates.documents), totalCount: templates.totalCount };
  }
}

function correctDates(templates: IDocument[]): IDocument[] {
  return templates.map((template: IDocument) => {
    return { ...template, createdAt: moment(template.createdAt).toISOString(true) };
  });
}
